import axios from "axios";
import store from "@/store";
import { throwErr } from "@/api/throw_err";
import { message } from "ant-design-vue";
import { uuc_api } from "./option";
import nVue from "n-vue";

const baseURL = "/water_api/";
const req = axios.create({
  baseURL: baseURL
});

const reqAuth = axios.create({
  baseURL: uuc_api
});

const reqSensor = axios.create({
  baseURL: baseURL
});

//请求拦截器
reqAuth.interceptors.request.use(
  config => {
    config.timeout = 5 * 60 * 1000; //请求响应时间
    if (config.url[0] === "/") {
      config.baseURL = "";
    }
    if (config.auth !== false) {
      if (store.state.token) {
        // 判断是否存在token，如果存在的话，则每个http header都加上token
        config.headers.Authorization = `Bearer ${store.state.token}`;
      } else {
        nVue.logout();
      }
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//请求拦截器
req.interceptors.request.use(
  config => {
    config.timeout = 5 * 60 * 1000; //请求响应时间
    if (config.url[0] === "/") {
      config.baseURL = "";
    }
    if (store.state.token) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.token = store.state.token;
      config.headers.Authorization = `Bearer ${store.state.token}`;
    } else {
      nVue.logout();
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 添加响应拦截器
req.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error && error.response) {
      error.message = throwErr(error.response.status); //throwErr 捕捉服务端的http状态码 定义在utils工具类的方法
      switch (error.response.status) {
        case 401:
          message.info("登录过期，请重新登录");
          nVue.logout();
          break;
      }
      switch (error.response?.data?.code) {
        case 401:
          message.info("登录过期，请重新登录");
          setTimeout(() => {
            nVue.logout();
          }, 1000);
          break;
      }
    } else {
      if (error.message != "stop request") {
        error.message = "连接到服务器失败";
      }
    }
    // if (error.message != "stop request" && error.message) {
    //   message.info(error.message);
    // }
    return Promise.reject(error);
  }
);

reqSensor.interceptors.request.use(
  config => {
    config.timeout = 5 * 60 * 1000; //请求响应时间
    if (config.url[0] === "/") {
      config.baseURL = "";
    }
    if (store.state.token) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = `Bearer ${store.state.token}`;
    } else {
      nVue.logout();
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 添加响应拦截器
reqSensor.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error && error.response) {
      error.message = throwErr(error.response.status); //throwErr 捕捉服务端的http状态码 定义在utils工具类的方法
      switch (error.response.status) {
        case 401:
          nVue.logout();
          break;
      }
    } else {
      if (error.message != "stop request") {
        error.message = "连接到服务器失败";
      }
    }
    if (error.message != "stop request" && error.message) {
      message.info(error.message);
    }
    return Promise.reject(error);
  }
);
export { req, reqAuth, reqSensor };
